import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const pmfmeRoutes: Routes = [
    {
        path: 'pmfme-nodal',
        title: 'PMFME Nodal',
        loadComponent: () =>
            import('../pmfme-admin/pmfme-nodal/pmfme-nodal/pmfme-nodal.component').then((m) => m.PmfmeNodalComponent),
        canActivate: [authGuard]
    },
    {
        path: 'pmfme-nodal/detail/:id',
        title: 'PMFME Nodal Detail',
        loadComponent: () =>
            import('../pmfme-admin/pmfme-nodal-detail/pmfme-nodal-detail.component').then(
                (m) => m.PmfmeNodalDetailComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'pmfme-block-manager',
        title: 'PMFME Block Manager',
        loadComponent: () =>
            import('../pmfme-admin/pmfme-block-manager/pmfme-block-manager.component').then(
                (m) => m.PmfmeBlockManagerComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'pmfme-block-manager/clf/:clfName',
        title: 'PMFME CLF Approval',
        loadComponent: () =>
            import('../pmfme-admin/pmfme-clf-approval/pmfme-clf-approval.component').then(
                (m) => m.PmfmeClfApprovalComponent
            ),
        canActivate: [authGuard]
    }
];

export const pmfmeMobileRoutes: Routes = [
    {
        path: 'mobile/pmfme/add-details',
        title: 'Add PMFME Details',
        loadComponent: () =>
            import('../mobile/pages/pmfme/add-pmfme/add-pmfme-details/add-pmfme-details.component').then(
                (m) => m.AddPmfmeDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/pmfme/pfme-list',
        title: 'Add PMFME Details',
        loadComponent: () =>
            import('../mobile/pages/pmfme/pfme-list/pfme-list.component').then((m) => m.PfmeListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/pmfme/view-details/:id',
        title: 'PMFME Scheme Details',
        loadComponent: () =>
            import('../mobile/pages/pmfme/view-scheme-details/view-scheme-details.component').then(
                (m) => m.ViewSchemeDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/pmfme/fund-util',
        title: 'PMFME Fund Utilization',
        loadComponent: () =>
            import('../mobile/pages/pmfme/fund-util/fund-util.component').then((m) => m.FundUtilComponent),
        canActivate: [authGuard]
    }
];
